var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col-md-4 left" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("sidebar.salesummary")) +
                    "\n          "
                ),
                _vm.ready
                  ? [
                      _vm._v(
                        "\n            >\n            " +
                          _vm._s(_vm.posSession.ps_code) +
                          "\n          "
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.ready
            ? _c("div", { staticClass: "col-md-8 right" }, [
                _c(
                  "div",
                  { staticClass: "action" },
                  [
                    _c("base-dropdown-filter-download", {
                      attrs: { items: _vm.DOWNLOAD_EXTS, loading: false },
                      on: { onSelect: _vm.handleSelectDownload }
                    }),
                    _vm._v(" "),
                    (_vm.posSession.status == "selling" ||
                      _vm.posSession.status == "paused") &&
                    _vm.hasRoleEdit
                      ? _c(
                          "div",
                          { staticClass: "dropdown item" },
                          [
                            [
                              _vm.posSession.status == "selling"
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-info",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "far fa-circle" }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("status.pos.selling")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.posSession.status == "paused"
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-warning",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "far fa-circle" }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("status.pos.paused")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-menu dropdown-menu-right"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.closeSession(
                                          _vm.posSession.ps_id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "far fa-check-circle text-success",
                                      staticStyle: {
                                        position: "relative",
                                        left: "-7px"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-success" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apps.pos.button.closesession"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hasRoleEdit
                      ? [
                          _vm.posSession.status == "selling"
                            ? _c(
                                "div",
                                { staticClass: "dropdown nodro item" },
                                [
                                  _c("span", { staticClass: "text-info" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("status.pos.selling")) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.posSession.status == "paused"
                            ? _c(
                                "div",
                                { staticClass: "dropdown nodro item" },
                                [
                                  _c("span", { staticClass: "text-warning" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("status.pos.paused")) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.posSession.status == "closed"
                            ? _c(
                                "div",
                                { staticClass: "dropdown nodro item" },
                                [
                                  _c("span", { staticClass: "text-success" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("status.pos.closed")) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.state.app.loading
                      ? _c("div", { staticClass: "dropdown nodro item" }, [
                          _c("i", { staticClass: "fas fa-spinner spin" })
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content col-md-12",
          staticStyle: { background: "var(--bg-grey-color)" }
        },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 no-padding",
                  staticStyle: { "margin-top": "10px" }
                },
                [
                  _c("div", { staticClass: "row no-margin dashboard" }, [
                    _c("div", { staticClass: "col-sm-12 col-lg-4 mb-3 item" }, [
                      _c("div", { staticClass: "outer" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "middle" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.getDurationFriendlyBySeconds(
                                  (_vm
                                    .moment(
                                      _vm.posSession.ended_at || new Date()
                                    )
                                    .format("x") -
                                    _vm
                                      .moment(_vm.posSession.started_at)
                                      .format("x")) /
                                    1000,
                                  _vm.$t,
                                  false
                                )
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bottom" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("apps.pos.message.saledurationtime")
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12 col-lg-4 mb-3 item" }, [
                      _c("div", { staticClass: "outer" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "middle" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.posSession.transactionInfo
                                  ? _vm.posSession.transactionInfo.count
                                  : 0
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bottom" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("apps.pos.message.transactions")) +
                              "\n            "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12 col-lg-4 mb-3 item" }, [
                      _c("div", { staticClass: "outer" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "middle" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.currencyFormatter(
                                  _vm.salesSummary.totalNet,
                                  { code: _vm.currency }
                                )
                              ) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bottom" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.nettotal")) +
                              "\n            "
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    {
                      staticClass: "table table-bordered",
                      staticStyle: { width: "100%" },
                      attrs: { id: "dataTable" }
                    },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(_vm.$t("message.date")))
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(_vm.$t("message.time")))
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v("#")
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.productlist")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-right",
                              staticStyle: { "min-width": "100px" }
                            },
                            [_vm._v(_vm._s(_vm.$t("message.totaldiscount")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-right",
                              staticStyle: { "min-width": "100px" }
                            },
                            [_vm._v(_vm._s(_vm.$t("message.totaltax")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-right",
                              staticStyle: { "min-width": "100px" }
                            },
                            [_vm._v(_vm._s(_vm.$t("message.totalcollected")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-right",
                              staticStyle: { "min-width": "100px" }
                            },
                            [_vm._v(_vm._s(_vm.$t("message.totalrefund")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "th",
                            {
                              staticClass: "text-right",
                              staticStyle: { "min-width": "100px" }
                            },
                            [_vm._v(_vm._s(_vm.$t("message.nettotal")))]
                          ),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-right" })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.posSession.transactions, function(
                          bill,
                          index
                        ) {
                          return _c(
                            "tr",
                            {
                              key: index,
                              class: [
                                {
                                  "table-warning": bill.posbi_code == _vm.ref
                                }
                              ],
                              attrs: { id: "ref-" + bill.posbi_code }
                            },
                            [
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.getDate(bill.created_at)) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getDateCustom(bill.created_at, {
                                        format: "H:mm"
                                      })
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(bill.posbi_code) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("item-list", {
                                    attrs: {
                                      orders: bill.orders,
                                      isShowPrice: true
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getNumber(
                                        _vm.getTotalPriceByItem(
                                          _vm.adjustModifiers(bill.orders)
                                        ).discount
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getNumber(
                                        _vm.getTotalPriceByItem(
                                          _vm.adjustModifiers(bill.orders)
                                        ).tax
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.getNumber(bill.total)) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-right",
                                  class: [
                                    {
                                      "text-warning":
                                        _vm.getTotalRefunds(bill.refunds) > 0
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getNumber(
                                          _vm.getTotalRefunds(bill.refunds)
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getNumber(
                                        bill.total -
                                          _vm.getTotalRefunds(bill.refunds)
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _c("div", { staticClass: "dropdown" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn no-bg dropdown-toggle",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.$t("message.option")) +
                                            "\n                  "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.detailModalOpen(bill)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-info-circle"
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.pos.message.transactiondetail"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.onclickPrint(bill)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-print"
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("message.printreceipt")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasRoleEdit
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function($event) {
                                                  return _vm.refundModalOpen(
                                                    bill
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-money-bill"
                                              }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.issuerefund"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "detailModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-md",
              attrs: { role: "document" }
            },
            [
              _vm.billDetail
                ? _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.psCode) +
                            "\n            #" +
                            _vm._s(_vm.billDetail.posbi_code) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "section",
                        [
                          _c("section-title", {
                            attrs: {
                              title: _vm.$t("message.detail"),
                              fontweight: "bold"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticStyle: { padding: "15px" } }, [
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.date")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.getDate(_vm.billDetail.created_at)
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.time")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.getDateCustom(
                                        _vm.billDetail.created_at,
                                        { format: "H:mm" }
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("apps.pos.message.ordernumber")
                                    ) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  #" +
                                    _vm._s(_vm.billDetail.posbi_code) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.productlist")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col orders" },
                                [
                                  _c("item-list", {
                                    attrs: {
                                      orders: _vm.billDetail.orders,
                                      isShowPrice: true
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.totaldiscount")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.getNumber(
                                        _vm.getTotalPriceByItem(
                                          _vm.adjustModifiers(
                                            _vm.billDetail.orders
                                          )
                                        ).discount
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.totaltax")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.getNumber(
                                        _vm.getTotalPriceByItem(
                                          _vm.adjustModifiers(
                                            _vm.billDetail.orders
                                          )
                                        ).tax
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.totalcollected")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.getNumber(_vm.billDetail.total)
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.billDetail.refunds.length > 0
                              ? _c("div", { staticClass: "row mb-3" }, [
                                  _c("div", { staticClass: "col-4" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("message.totalrefund")) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col" }, [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          _vm.getTotalRefunds(
                                            _vm.billDetail.refunds
                                          ) > 0
                                            ? "text-warning"
                                            : ""
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.getNumber(
                                                _vm.getTotalRefunds(
                                                  _vm.billDetail.refunds
                                                )
                                              )
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.nettotal")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.getNumber(
                                        _vm.billDetail.total -
                                          _vm.getTotalRefunds(
                                            _vm.billDetail.refunds
                                          )
                                      )
                                    ) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.pos.message." +
                                          _vm.billDetail.payment.type
                                      )
                                    ) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _c("span", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.getNumber(
                                          _vm.billDetail.payment.amount
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.billDetail.payment.type ===
                            _vm.POS_PAYMENT_METHOD.CASH
                              ? _c("div", { staticClass: "row mb-3" }, [
                                  _c("div", { staticClass: "col-4" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("message.cashchange")) +
                                        "\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.getNumber(
                                            _vm.billDetail.payment.amount -
                                              _vm.billDetail.total
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-3" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.customer")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col" },
                                [
                                  _vm.billDetail.customer
                                    ? _c("router-link-custom", {
                                        attrs: {
                                          to: {
                                            name: "ContactCustomerEdit",
                                            query: {
                                              cus_id:
                                                _vm.billDetail.customer
                                                  .customer_id,
                                              cus_name:
                                                _vm.billDetail.customer
                                                  .customer_name
                                            }
                                          },
                                          text:
                                            _vm.billDetail.customer
                                              .customer_name,
                                          to_appid: 11,
                                          current_appid: 1,
                                          disabled:
                                            _vm.billDetail.customer
                                              .is_deleted == true
                                        }
                                      })
                                    : _c("span", [_vm._v("-")])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-4" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.cashier")) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.billDetail.user.email ||
                                        _vm.billDetail.user.username
                                    ) +
                                    "\n                "
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.billDetail.refunds.length > 0
                        ? _c(
                            "section",
                            { staticClass: "pt-1" },
                            [
                              _c("section-title", {
                                attrs: {
                                  title: _vm.$t("apps.pos.message.issuerefund"),
                                  fontweight: "bold"
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.billDetail.refunds, function(
                                refund,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticStyle: {
                                      background: "rgba(216, 226, 231, .25)",
                                      "margin-bottom": "10px",
                                      padding: "15px"
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "row mb-3" }, [
                                      _c("div", { staticClass: "col-4" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "apps.pos.message.issuerefundreason"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col" }, [
                                        refund.reason_id == null
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(refund.reason_custom) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "apps.pos.message.issuerefundreason" +
                                                        refund.reason_id
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row mb-3" }, [
                                      _c("div", { staticClass: "col-4" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("message.date")) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getDate(refund.created_at)
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row mb-3" }, [
                                      _c("div", { staticClass: "col-4" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("message.time")) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getDateCustom(
                                                refund.created_at,
                                                { format: "H:mm" }
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row mb-3" }, [
                                      _c("div", { staticClass: "col-4" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "apps.pos.message.issuerefundamount"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.getNumber(refund.amount)
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    refund.orders.length > 0
                                      ? _c("div", { staticClass: "row mb-3" }, [
                                          _c("div", { staticClass: "col-4" }, [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("message.productlist")
                                                ) +
                                                "\n                "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col" },
                                            _vm._l(refund.orders, function(
                                              order,
                                              index
                                            ) {
                                              return _c(
                                                "span",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "badge badge-secondary",
                                                  staticStyle: {
                                                    "margin-right": "5px"
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProductName(
                                                          order.sku_id
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  order.quantity
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "x" +
                                                            _vm._s(
                                                              order.quantity
                                                            )
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-4" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("message.createdby")
                                            ) +
                                            "\n                "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col" }, [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              refund.user.email ||
                                                refund.user.username
                                            ) +
                                            "\n                "
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    !_vm.$store.state.app.loading
                      ? _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-light",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.detailModalClose()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.close")))]
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "refundModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-md",
              attrs: { role: "document" }
            },
            [
              _vm.billDetail
                ? _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("apps.pos.message.issuerefund")) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "modal-body" },
                      [
                        _c(
                          "section",
                          [
                            _c("section-title", {
                              attrs: {
                                title: _vm.$t(
                                  "apps.pos.message.issuerefundreason"
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.refund.reason_id,
                                    expression: "refund.reason_id"
                                  }
                                ],
                                staticClass: "form-control custom-select",
                                class: _vm.refundValidate.reason_id,
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.refund,
                                      "reason_id",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "", disabled: "" } },
                                  [_vm._v(_vm._s(_vm.$t("placeholder.select")))]
                                ),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "apps.pos.message.issuerefundreason2"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "apps.pos.message.issuerefundreason1"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "3" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "apps.pos.message.issuerefundreason3"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "custom" } }, [
                                  _vm._v(_vm._s(_vm.$t("message.custom")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.refund.reason_id == "custom"
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.refund.reason_custom,
                                      expression: "refund.reason_custom"
                                    }
                                  ],
                                  ref: "custom-refund",
                                  staticClass: "form-control mt-2",
                                  class: _vm.refundValidate.reason_custom,
                                  attrs: {
                                    placeholder: _vm.$t("message.message"),
                                    type: "text"
                                  },
                                  domProps: { value: _vm.refund.reason_custom },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.refund,
                                        "reason_custom",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.refund.reason_id
                          ? _c(
                              "section",
                              [
                                _c("section-title", {
                                  attrs: {
                                    title: _vm.$t("message.productlist")
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "refund assign-items",
                                    class: [
                                      {
                                        "bordered-red":
                                          _vm.isShowRefundAmount == false
                                      }
                                    ]
                                  },
                                  _vm._l(_vm.mapItems, function(item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "col-md-12 row align-items-center no-padding no-margin item",
                                        class: [{ active: item.active }],
                                        style: [
                                          {
                                            "pointer-events": item.disabled
                                              ? "none"
                                              : ""
                                          }
                                        ]
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 no-margin row display",
                                            style: [
                                              {
                                                opacity: item.disabled
                                                  ? "0.2"
                                                  : "1"
                                              }
                                            ],
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleAssign(index)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-10",
                                                staticStyle: {
                                                  "padding-left": "10px"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(item.name) +
                                                    "\n                    "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-light"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.currencyFormatter(
                                                            item.price,
                                                            {
                                                              code: _vm.currency
                                                            }
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(3, true)
                                          ]
                                        ),
                                        _vm._v(" "),
                                        item.active && _vm.hasStock(item.sku_id)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 no-margin row stock-return-input"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "d-flex" },
                                                  [
                                                    _c(
                                                      "vs-checkbox",
                                                      {
                                                        staticClass:
                                                          "no-margin",
                                                        staticStyle: {
                                                          "font-size": "12px"
                                                        },
                                                        attrs: {
                                                          value:
                                                            item.return_stock
                                                              .active,
                                                          color: "#A3CA76"
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.toggleReturnStock(
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "apps.pos.message.returnstock"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                item.return_stock.active
                                                  ? [
                                                      _c("div", [
                                                        _c(
                                                          "select",
                                                          {
                                                            class:
                                                              "form-control custom-select " +
                                                              (!item
                                                                .return_stock
                                                                .wh_id &&
                                                                "is-invalid"),
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.selectReturnStockToWarehouse(
                                                                  $event,
                                                                  index
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "option",
                                                              {
                                                                attrs: {
                                                                  disabled: ""
                                                                },
                                                                domProps: {
                                                                  value: -1,
                                                                  selected: !item
                                                                    .return_stock
                                                                    .wh_id
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          -- " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "apps.inventory.message.selectwarehouse"
                                                                      )
                                                                    ) +
                                                                    " --\n                        "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              _vm.warehouses
                                                                .filter(
                                                                  function(wh) {
                                                                    return _vm.hasStockIn(
                                                                      item.sku_id,
                                                                      wh.warehouse_id
                                                                    )
                                                                  }
                                                                )
                                                                .reduce(
                                                                  function(
                                                                    acc,
                                                                    cur
                                                                  ) {
                                                                    var wh = cur

                                                                    var isWhIdExist = acc.find(
                                                                      function(
                                                                        whItem
                                                                      ) {
                                                                        return (
                                                                          whItem.wh_id ===
                                                                          wh.warehouse_id
                                                                        )
                                                                      }
                                                                    )
                                                                    if (
                                                                      !isWhIdExist
                                                                    ) {
                                                                      acc.push({
                                                                        text:
                                                                          "" +
                                                                          _vm.getWarehouseNameById(
                                                                            wh.warehouse_id
                                                                          ),
                                                                        wh_id:
                                                                          wh.warehouse_id,
                                                                        bin_location_id: null
                                                                      })
                                                                    }

                                                                    if (
                                                                      wh
                                                                        .bin_locations
                                                                        .length >
                                                                      0
                                                                    ) {
                                                                      wh.bin_locations.forEach(
                                                                        function(
                                                                          bin
                                                                        ) {
                                                                          acc.push(
                                                                            {
                                                                              text:
                                                                                _vm.getWarehouseNameById(
                                                                                  wh.warehouse_id
                                                                                ) +
                                                                                " - " +
                                                                                bin.code,
                                                                              wh_id:
                                                                                wh.warehouse_id,
                                                                              bin_location_id:
                                                                                bin._id
                                                                            }
                                                                          )
                                                                        }
                                                                      )
                                                                    }
                                                                    return acc
                                                                  },
                                                                  []
                                                                ),
                                                              function(
                                                                warehouse,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    key: index,
                                                                    domProps: {
                                                                      value:
                                                                        warehouse.wh_id +
                                                                        "-" +
                                                                        warehouse.bin_location_id
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          warehouse.text
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "apps.inventory.label.unit"
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    item
                                                                      .return_stock
                                                                      .quantity,
                                                                  expression:
                                                                    "item.return_stock.quantity"
                                                                }
                                                              ],
                                                              class:
                                                                "form-control text-right number-only text-select-all " +
                                                                (parseFloat(
                                                                  item
                                                                    .return_stock
                                                                    .quantity
                                                                ) === 0 &&
                                                                  "is-invalid"),
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item
                                                                    .return_stock
                                                                    .quantity
                                                              },
                                                              on: {
                                                                keypress:
                                                                  _vm.numberOnly,
                                                                keyup: function(
                                                                  $event
                                                                ) {
                                                                  item.return_stock.quantity = _vm.setToValidNumber(
                                                                    item
                                                                      .return_stock
                                                                      .quantity
                                                                  )
                                                                },
                                                                blur: function(
                                                                  $event
                                                                ) {
                                                                  item.return_stock.quantity = _vm.setToCustomDigitsNumber(
                                                                    item
                                                                      .return_stock
                                                                      .quantity
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    item.return_stock,
                                                                    "quantity",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _vm.items.length > 1
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "11px",
                                          color: "#ccc",
                                          "margin-top": "10px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "apps.pos.message.chooseoneitempertime"
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShowRefundAmount
                          ? [
                              _c(
                                "section",
                                [
                                  _c("section-title", {
                                    attrs: {
                                      title:
                                        _vm.$t(
                                          "apps.pos.message.issuerefundamount"
                                        ) + " *"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-prepend"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.totalrefund"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.refund.amount,
                                                expression: "refund.amount"
                                              }
                                            ],
                                            ref: "amount-refund",
                                            staticClass:
                                              "form-control text-select-all",
                                            class: _vm.refundValidate.amount,
                                            domProps: {
                                              value: _vm.refund.amount
                                            },
                                            on: {
                                              keypress: _vm.numberOnly,
                                              keyup: function($event) {
                                                _vm.refund.amount = _vm.setToValidNumber(
                                                  _vm.refund.amount
                                                )
                                              },
                                              blur: function($event) {
                                                _vm.refund.amount = _vm.setToCustomDigitsNumber(
                                                  _vm.refund.amount
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.refund,
                                                  "amount",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-prepend"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-sync-alt",
                                                    staticStyle: {
                                                      "margin-right": "5px"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.nettotal"
                                                        )
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass:
                                              "form-control text-right",
                                            attrs: {
                                              disabled: true,
                                              type: "text"
                                            },
                                            domProps: {
                                              value: _vm.refund.newresult
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    !_vm.$store.state.app.loading
                      ? _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-light btn-block-mobile-only",
                              on: {
                                click: function($event) {
                                  return _vm.refundModalClose()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.close")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-web",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.insertRefund()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.save")))]
                          )
                        ])
                      : _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-light btn-block-mobile-only",
                              attrs: { disabled: "" }
                            },
                            [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                          ),
                          _vm._v(" "),
                          _vm._m(4)
                        ])
                  ])
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.ready
        ? _c("receipt-view", {
            staticClass: "receipt-template",
            staticStyle: {
              position: "fixed",
              "z-index": "-1",
              top: "1mm",
              left: "1mm",
              "font-family": "tahoma",
              color: "black",
              width: "100%"
            },
            attrs: {
              shop_logo: _vm.receiptInfoProps.shopLogo,
              shop_name: _vm.receiptInfoProps.shopName,
              shop_address: _vm.receiptInfoProps.shopAddress,
              shop_tax_id: _vm.receiptInfoProps.shopTaxId,
              shop_tax_title: _vm.receiptInfoProps.shopTaxTitle,
              shop_tel: _vm.receiptInfoProps.shopTel,
              orders: _vm.receiptInfoProps.orders,
              total_price: _vm.receiptInfoProps.totalPrice,
              receipt_info: _vm.receiptInfoProps.receiptInfo,
              date_time: _vm.receiptInfoProps.dateTime,
              text_footer: _vm.receiptInfoProps.textFooter,
              font_size: _vm.receiptInfoProps.fontSize
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("i", { staticClass: "fas fa-clock" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("i", { staticClass: "fas fa-clipboard-list" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("i", { staticClass: "fas fa-hand-holding-usd" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-2 text-right",
        staticStyle: { "padding-right": "10px" }
      },
      [
        _c("i", {
          staticClass: "fas fa-check-circle",
          staticStyle: { color: "#A3CA76", "font-size": "15px" }
        }),
        _vm._v(" "),
        _c("i", { staticClass: "far fa-circle" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-535365ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535365ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/transaction/Detail.vue
// module id = null
// module chunks = 